import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AOS from 'aos';

import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './landing.layout.css';

import Header from '../components/header.component';
import Footer from '../components/footer.component';
import ChatWidget from 'components/chat-widget.component';
import { useDynamicFont } from '../hooks/dynamic-font.hook';
import { getVendorDetails } from 'services/auth.service';
import { useVendor } from "contexts/vendor.context";

function LandingLayout() {
  useDynamicFont("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
  const { setVendor } = useVendor();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const vendorsResponse = await getVendorDetails();
        setVendor(vendorsResponse.data)
      } catch (error: any) {
        console.log(error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <main className="main" style={{ marginTop: "5rem" }}>
        <Outlet />
      </main>
      <Footer />

      <ChatWidget />
    </>
  );
}

export default LandingLayout;
